import { useNavigate } from "react-router-dom";

export const useMovePage = () => {
    const navigate = useNavigate();

    return {
        back : () => navigate(-1),
        go   : (url) => navigate(url)
    }
}